import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { handleReportDownload } from './action';
import {
  allowedRolesSetForConfigure,
  allowedRolesSetForViewReportStatus,
  REPORTS
} from './constant';
import { ReportTypes } from './interface';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { useNavigate } from 'react-router';
import APP_ROUTES from '@cp/src/layout/Routes';
import { Roles } from '../auth/constants/AuthConstants';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import DownloadReportIcon from '@cp/src/assets/icons/DownloadReportIcon';
import SettingsIcon from '@cp/src/assets/icons/SettingsIcon';

const Reports = () => {
  const navigate = useNavigate();

  const roles = useSelector((state: RootState) => state.common.userData.roles);
  const handleViewReportStatusClick = () => {
    navigate(APP_ROUTES.VIEW_REPORT_STATUS.path);
  };

  const handleReportClick = (report: ReportTypes) => {
    addClickstreamEvent(report.clickStreamEvent);
    handleReportDownload(report.type);
  };

  const handleConfigureClick = () => {
    navigate(APP_ROUTES.CONFIGURE_REPORTS.path);
  };

  const showViewReportStatus = roles?.some(role =>
    allowedRolesSetForViewReportStatus.has(role as Roles)
  );

  const showConfigureButton = roles?.some(role => allowedRolesSetForConfigure.has(role as Roles));

  return (
    <div className={styles.reportsContainer}>
      <div className={styles.reportsHeader}>
        <Typography variant="h1" color="var(--navi-color-gray-c1)">
          Reports
        </Typography>
        {showConfigureButton ? (
          <Button variant="text" onClick={handleConfigureClick} startAdornment={<SettingsIcon />}>
            <Typography variant="h4" color="var(--navi-color-blue-base)">
              Configure
            </Typography>
          </Button>
        ) : null}
      </div>
      <div className={styles.reportsGrid}>
        <>
          {REPORTS.map((report: ReportTypes) => {
            return report.isVisible(roles ?? []) ? (
              <Button
                key={report.id}
                className={styles.reportButton}
                onClick={() => handleReportClick(report)}
                variant="secondary"
                size="medium"
                startAdornment={<DownloadReportIcon />}
              >
                <Typography
                  className={'ml-3 w-[200px]'}
                  variant="h4"
                  color="var(--navi-color-gray-c1)"
                >
                  {report.title}
                </Typography>
              </Button>
            ) : null;
          })}

          {showViewReportStatus ? (
            <Button
              className={styles.reportButton}
              onClick={handleViewReportStatusClick}
              variant="secondary"
              size="medium"
              startAdornment={<DownloadReportIcon />}
            >
              <Typography
                className={'ml-3 w-[200px]'}
                variant="h4"
                color="var(--navi-color-gray-c1)"
              >
                View report status
              </Typography>
            </Button>
          ) : null}
        </>
      </div>
    </div>
  );
};

export default Reports;
